import React from 'react';
import { dayExamples } from '../data/content';
export function DayPath() {
  return <section id="contenido" className="w-full bg-parchment py-14 md:py-24" data-id="element-43" data-mp="q9qvzh6vln6c">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-44" data-mp="q7nwm6ju2hoy">
        <header className="mx-auto max-w-3xl text-center" data-id="element-45" data-mp="v21xupl6fj1j">
          <h2 className="font-serif text-3xl font-semibold leading-tight text-ink md:text-5xl" data-id="element-46" data-mp="zzk3o73wdi5b">
            31 días. <span className="italic text-wine" data-id="element-47" data-mp="2cl3hmdzxs2o">Un camino junto a María.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg text-muted md:text-xl" data-id="element-48" data-mp="7awj6dqz2wst">
            Todo está organizado para que simplemente abras el día que corresponde y comiences.
          </p>
        </header>

        <ol className="relative mx-auto mt-10 grid max-w-md gap-3 md:mt-14 md:max-w-none md:grid-cols-5 md:gap-4" data-id="element-49" data-mp="gcch3m0lp6g5">
          {dayExamples.map(item => <li key={item.day} className="flex h-full items-center gap-4 rounded-2xl bg-ivory px-5 py-4 shadow-soft ring-1 ring-line md:flex-col md:items-start md:gap-3 md:p-5" data-id="element-50" data-mp="1nrh4721wcnr4">
              <span className="shrink-0 rounded-full bg-wine px-3 py-1 text-xs font-bold uppercase tracking-[0.14em] text-white" data-id="element-51" data-mp="3uwcgzn7x2b4x">
                {item.day}
              </span>
              <span className="font-serif text-lg font-semibold leading-snug text-ink md:text-xl" data-id="element-52" data-mp="3pzca5a38t4cr">
                {item.title}
              </span>
            </li>)}
        </ol>

        <p className="mx-auto mt-10 max-w-2xl text-center text-lg italic text-muted md:text-xl" data-id="element-53" data-mp="3gxw238zwhebp">
          Y así, día tras día, durante todo el camino de octubre.
        </p>
      </div>
    </section>;
}